import { render, staticRenderFns } from "./MoreOption.vue?vue&type=template&id=4645161b"
import script from "./more-option.ts?vue&type=script&lang=ts&external"
export * from "./more-option.ts?vue&type=script&lang=ts&external"
import style0 from "./more-option.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports